/**
 * Baseline suggestions for skill inputs (e.g. a job's Required Skills), so
 * type-ahead is useful even before many students have added skills. Merged
 * at runtime with real student skills from CandidateFilterOptionsController.
 */
// prettier-ignore
export const COMMON_SKILLS: readonly string[] = [
  // Web and frontend
  'HTML', 'HTML5', 'CSS', 'CSS3', 'JavaScript', 'TypeScript', 'React', 'React Native', 'Next.js',
  'Angular', 'Vue.js', 'jQuery', 'Bootstrap', 'Tailwind CSS', 'Sass', 'Redux', 'Webpack', 'Vite',
  // Backend
  'Node.js', 'Express.js', 'NestJS', 'PHP', 'Laravel', 'CodeIgniter', 'WordPress', 'Python', 'Django',
  'Flask', 'FastAPI', 'Java', 'Spring', 'Spring Boot', 'Hibernate', 'J2EE', 'C', 'C++', 'C#', '.NET',
  'ASP.NET', 'Go', 'Rust', 'Ruby', 'Ruby on Rails', 'Kotlin', 'Scala', 'Perl', 'GraphQL', 'REST APIs',
  'Microservices',
  // Mobile
  'Android', 'iOS', 'Swift', 'Flutter', 'Dart', 'Xamarin',
  // Data and databases
  'SQL', 'MySQL', 'PostgreSQL', 'Oracle', 'SQL Server', 'MongoDB', 'Redis', 'Elasticsearch',
  'Cassandra', 'Firebase', 'SQLite', 'Hadoop', 'Hive', 'Spark', 'Kafka', 'Airflow', 'Snowflake',
  'Databricks', 'ETL', 'Data Analysis', 'Data Visualization', 'Power BI', 'Tableau', 'Excel',
  'Advanced Excel', 'Statistics', 'R',
  // AI and ML
  'Machine Learning', 'Deep Learning', 'Artificial Intelligence', 'Generative AI', 'NLP',
  'Computer Vision', 'TensorFlow', 'PyTorch', 'Keras', 'Scikit-learn', 'Pandas', 'NumPy', 'OpenCV',
  'LLMs', 'Prompt Engineering', 'Data Science',
  // Cloud and DevOps
  'AWS', 'Microsoft Azure', 'Google Cloud', 'Docker', 'Kubernetes', 'Jenkins', 'Terraform', 'Ansible',
  'CI/CD', 'Linux', 'Shell Scripting', 'Bash', 'Git', 'GitHub', 'GitLab', 'Nginx', 'Apache',
  // Testing and quality
  'Manual Testing', 'Automation Testing', 'Selenium', 'Cypress', 'Playwright', 'JUnit', 'Jest',
  'Postman', 'API Testing', 'JMeter',
  // Security and networking
  'Cyber Security', 'Ethical Hacking', 'Network Security', 'Networking', 'CCNA', 'Firewall',
  // Enterprise and other tech
  'SAP', 'Salesforce', 'ServiceNow', 'Blockchain', 'IoT', 'Embedded Systems', 'Arduino',
  'Raspberry Pi', 'MATLAB', 'AutoCAD', 'SolidWorks', 'CATIA', 'PLC', 'SCADA', 'VLSI', 'Verilog',
  // Design
  'UI Design', 'UX Design', 'Figma', 'Adobe XD', 'Adobe Photoshop', 'Adobe Illustrator', 'Canva',
  'Graphic Design', 'Video Editing',
  // Business and professional
  'Communication', 'Teamwork', 'Problem Solving', 'Leadership', 'Time Management',
  'Project Management', 'Agile', 'Scrum', 'Jira', 'Business Analysis', 'Digital Marketing', 'SEO',
  'Social Media Marketing', 'Content Writing', 'Sales', 'Customer Service', 'Tally', 'Accounting',
  'MS Office', 'Hindi', 'English',
]
